module.exports = __webpack_public_path__ + "static/graph-e87da391901c4276a27c18399987e63f.jpeg";